const EntitySearchesLegal = {
    "items": {
        'categories': ['QUANTITY'],
        'date': '',
        'id': '',
        'items': [
            {
                'BeginOffset': '1097',
                'EndOffset': 1100,
                'Score': "0.99",
                "Type": "QUANTITY",
                'entity': "42%",
                "file_name": 'LegalAidBC-Everyday-legal-needs-survey-2020',
                'id': '',
                'keyword': '',
                'page': 7,
                'snippet': 'olice Incidents 17% 12% The justice system in British Problems Experienced Columbia is effective at <b class="search-result">42%</b> 37% 21% > (% experiencing legal Legal Action Problems 16% 7% resolving legal problems problem in th'
            },
             {
                'BeginOffset': '494',
                'EndOffset': 497,
                'Score': "0.99",
                "Type": "QUANTITy",
                'entity': "37%",
                "file_name": 'LegalAidBC-Everyday-legal-needs-survey-2020',
                'id': '',
                'keyword': '',
                'page': 9,
                'snippet': "a consumer Fair 2% Sought legal assistance 54% problem in the past 3 years 11% VS. 12% Did Not Take <b class='search-result'>37%</b> VS. 39% Unfair Action 10% 9% Problem was direct result of COVID-19 30% Felt the problem was not ser"
            },
             {
                'BeginOffset': '1226',
                'EndOffset': 1228,
                'Score': "1.0",
                "Type": "QUANTITy",
                'entity': "7%",
                "file_name": 'LegalAidBC-Everyday-legal-needs-survey-2020',
                'id': '',
                'keyword': '',
                'page': 8,
                'snippet': 'esolved Among the 37% of low-income British Columbians who feel their problem would have Dont know <b class="search-result">7%</b> had a better outcome with more assistance, the majority (57%) feel that increased or better availab'
            },
             {
                'BeginOffset': '36',
                'EndOffset': 37,
                'Score': "0.95",
                "Type": "QUANTITY",
                'entity': "18",
                "file_name": 'a-vision-for-publicly-funded-legal-aid-in-british-columbia',
                'id': '',
                'keyword': '',
                'page': 1,
                'snippet': 'The Law Society of British Columbia <b class="search-result">18</b> SOCIETY OF BRITISH A Vision for Publicly Funded Legal Aid in British Columbia As approved by the Be'
            },
            
        ],
        'keyword': '',
        'project_id': "Legal",
        'type': 'entity'
    },
    "report_id": ""
}
export default EntitySearchesLegal; 